module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABUElEQVQ4T6WSv0sDMRTH38t1OI2T4NSjNFmUwi1ugpObVHRycxARBUfpn6F/gEJXR/8C14KOzt4lkUNnpUfRInmSI4VyFlLpg/x4Ce+TfN97CN6azWYSx3HqXGvtDiIeTe7cSkQPjLE7v8+UUi9uj25qtVqdRqMxAIB3H7QGAG5M2ycAvLkDznlnNBpt53k+qABCiDNE3FdK7Tk/SZLVKIrWp6Otta9FUVQPpGlKZVmea61vK4CU8oSIDrXWu7VXZ7oecKq17s8CMCHEDSIu1aLH1toLY8xXCIBSymMiWqklcWyM6QPATwgQVBECOAmXiMjrEpRS1wAwDgKklFdE9AcQRVEvy7LvEGBhCa6sXSJa9iRyXWiM+ZiQQz9wObhHxEkVHKCntX6eF/B/Cb6VD5RS3WD0rFZut9sbjLEnAMjmAXDON4fD4ZYx5rFq5UXsF/+VEyAnOBunAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geren/nav_btn_order_nor.png
// module id = ZoUD
// module chunks = 1